import { css, html } from 'lit';
import { property } from 'lit/decorators.js';
import { KryptonElement } from './krypton-element';

export const DEFAULT_VERSION: string = "4.2.0";

export type ENVIRONMENT = "prod" | "aprod" | "dr" | "drtest" | "stage" | "site" | "dev" | "local"; //TODO make this toggleable by the user on LOCAL 'onEnvironmentChange' etc

export class AppVersion extends KryptonElement {

    @property({ type: String }) accessor version: string = DEFAULT_VERSION;
    @property({ type: String }) accessor environment: ENVIRONMENT = "local";
    @property({ type: String }) accessor branch: string = "";

    static styles = css`
      #version::before {
          display: inline;
          content: '\\00ae  v';
          white-space: pre;
      }
    `;

    render() {
        switch (this.environment) {
            case "prod":
            case "aprod":
            case "dr":
                return html`<span id="version">${this.version}</span>`
            case "drtest":
            case "stage":
            case "site":
            case "dev":
            case "local":
            default:
                return html`<span id="version">${this.version} ${this.environment} ${this.branch}</span>`;
        };

    }

}

declare global {
    interface HTMLElementTagNameMap {
        'app-version': AppVersion;
    }
}
